import type {TAPIElementFieldNames} from '@/assets/core/assets/api/types';
import type {IRole, IRoleUpdate} from '@/api/types/role';

import {roleAPI} from '@/api/requesters/role';
import {roleSyncAPI} from '@/api/requesters/roleSync';

const fieldNames: TAPIElementFieldNames<IRoleUpdate> = {
  pageTitle: 'Роли',
  drawerTitle: 'Роль',

  name: 'Название техническое',
  alias: 'Название',
};

const useRoleControllerHook = () => {
  const api = roleAPI.clone();

  const getOneByName = async (name: string): Promise<IRole> => {
    const list = await roleAPI.cloneWithParams({search: name}).list.loadPage();
    return list[0];
  };

  const validate = (form?: IRoleUpdate) => !!form?.name;

  const sync = async () => {
    await roleSyncAPI.createOne({});
  };

  return {
    ...api,
    fieldNames,

    validate,
    getOneByName,
    sync,
  };
};

const roleController = useRoleControllerHook();

export default roleController;
